export default {
    methods: {
        formatDate(date){
            if(!date || date == ''){
                return '';
            }
            var dte=new Date(date);
            return dte.getDate()+'-'+(dte.getMonth() +1 )+'-'+dte.getFullYear();
        },
        cleanDate(date){
            if(date == null){
                return '';
            }
            return date.split(' ')[0];
        },
        reduceString(data,limit){
            if(!data) return data
            return data.length > limit ? data.substr(0,limit)+'...' : data;
        },
    },
}